import ("pixi.js");
declare global {
    interface Window {
        PIXI: any;
        NolimitLauncher: NolimitLauncher;
    }
}

import * as PIXI from "pixi.js";
window.PIXI = PIXI;

require("pixi-spine");

import { NolimitPromotionPlugin } from "@nolimitcity/promo-panel/bin/NolimitPromotionPlugin";
import { NolimitGameIntroPlugin } from "@nolimitcity/slot-launcher/bin/plugins/concreteplugins/NolimitGameIntroPlugin";
import { NolimitLauncher } from "@nolimitcity/slot-launcher/bin/NolimitLauncher";
import { NolimitSlotAudio } from "@nolimitcity/slot-audio/bin/NolimitSlotAudio";
import { SlotKeypad } from "@nolimitcity/slot-keypad/bin/SlotKeypad";

window.NolimitLauncher = NolimitLauncher.instance;

import { gsap } from "gsap"
import { CustomEase } from "gsap/dist/CustomEase";
import { EasePack } from "gsap/dist/EasePack"

import { PunkRocker } from "./game/PunkRocker";
import { PunkRockerIntroConfig } from "./game/intro/PunkRockerIntroConfig";
import {PunkRocker2PromoPanelConfig} from "./game/PunkRocker2PromoPanelConfig";

gsap.registerPlugin(CustomEase);
gsap.registerPlugin(EasePack);

NolimitLauncher.instance.launch([
    new PunkRocker(),
    new SlotKeypad(),
    new NolimitGameIntroPlugin(new PunkRockerIntroConfig()),
    new NolimitSlotAudio(),
    new NolimitPromotionPlugin(new PunkRocker2PromoPanelConfig())
]);
